// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"d3a09e6c","550":"cb67c8ee","661":"f59a511f","723":"7b042ecb","927":"3f483b72","979":"2efed84d"}[chunkId] + ".chunk.js";
};